import { CalendarTodayIcon } from '@src/shared/ui/icons';
import { useState } from 'react';

import DateField from './DateField';

type DatePickerFieldProps = {
  name: string;
  slotProps?: Record<string, unknown>;
  slots?: Record<string, unknown>;
  onOpen?: (...args: unknown[]) => void;
  onClose?: (...args: unknown[]) => void;
  [key: string]: unknown;
};

function DatePickerField(props: DatePickerFieldProps) {
  const [open, setOpen] = useState(false);
  const {
    name,
    slotProps = {},
    slots = {},
    onClose,
    onOpen,
    ...rest
  } = props;

  const textFieldSlotProps = (slotProps.textField ?? {}) as Record<string, unknown>;
  const inputProps = (textFieldSlotProps.InputProps ?? {}) as Record<string, unknown>;
  const textFieldOnClick = textFieldSlotProps.onClick as ((event: unknown) => void) | undefined;

  return (
    <DateField
      name={name}
      {...rest}
      open={open}
      onOpen={(...args: unknown[]) => {
        setOpen(true);
        (onOpen as ((...cbArgs: unknown[]) => void) | undefined)?.(...args);
      }}
      onClose={(...args: unknown[]) => {
        setOpen(false);
        (onClose as ((...cbArgs: unknown[]) => void) | undefined)?.(...args);
      }}
      slots={{
        ...(slots as Record<string, unknown>),
        openPickerButton: () => null,
      }}
      slotProps={{
        ...(slotProps as Record<string, unknown>),
        textField: {
          ...textFieldSlotProps,
          InputProps: {
            startAdornment: <CalendarTodayIcon />,
            ...inputProps,
          },
          onClick: (event: unknown) => {
            setOpen(true);
            textFieldOnClick?.(event);
          },
        },
      }}
    />
  );
}

export default DatePickerField;
